module.exports = __webpack_public_path__ + "static/media/force.4e397840.PNG";